import { useEffect } from 'react';
import { getConvertTrackMethod } from './getConvertTrackMethod';
export const useConvertTrack = goalType => {
  useEffect(() => {
    const convertTrackMethod = getConvertTrackMethod(goalType);
    convertTrackMethod();
  }, [goalType]);
};